export default "__VITE_ASSET__33190b94__"